import gql from 'graphql-tag'

export const CUSTOM_REPORT = gql`
    query($input: CustomReportInput!) {
        customReport(input: $input)
    }
`
